var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.count >= 0 && _vm.count < 100)?_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar__title"},[_vm._t("default")],2),_c('div',{staticClass:"progress-bar__rail"},[_c('div',{staticClass:"progress-bar__bar",style:({ width: `${_vm.count}%` })},[_vm._v(" "+_vm._s(Math.round(_vm.count))+"% ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }